import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MainPage = () => {

    const navigate = useNavigate();

    const [jobDescription, setJobDescription] = useState(sessionStorage.getItem("jobDescription") || "");
    const [resume, setResume] = useState(sessionStorage.getItem("resume") || "");

    const handleWebInterview = async () => {
        if (jobDescription.trim() === "") {
            alert("Please enter a job description");
            return;
        }
        if (resume === "") {
            alert("Please enter your resume");
            return;
        }
        sessionStorage.setItem('jobDescription', jobDescription);
        sessionStorage.setItem('resume', resume);

        navigate('/interview');
    }

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>Welcome To Your Virtual AI Interviewer</h1>
                <p style={styles.subtitle}>Fill out the information below to start your practice interview</p>
            </header>
            <main style={styles.main}>
                <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>Your Resume</h2>
                    <textarea
                        value={resume}
                        onChange={(e) => setResume(e.target.value)}
                        placeholder="Paste your resume here..."
                        rows={5}
                        style={styles.textarea}
                    />
                </section>
                <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>Job Description</h2>
                    <textarea
                        value={jobDescription}
                        onChange={(e) => setJobDescription(e.target.value)}
                        placeholder="Paste the job description here..."
                        rows={5}
                        style={styles.textarea}
                    />
                </section>
                <button onClick={handleWebInterview} style={styles.button}>
                    Start Web Interview
                </button>
                <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>About Us</h2>
                    <p style={styles.text}>
                        Learn more about our mission and values. Interviewing is not easy, and we are here to help.
                    </p>
                    <p style={styles.text}>
                        This is a true passion project by applicants for applicants to help you land the job you have worked so hard for.
                    </p>
                    <p style={styles.text}>
                        Upload the job description and your resume, then select "Phone Interview" or "Web Interview" to begin.
                    </p>
                </section>
                <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>Features</h2>
                    <p style={styles.text}>Explore the features of our application.</p>
                </section>
                <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>Contact</h2>
                    <p style={styles.text}>Get in touch with us today!</p>
                </section>
            </main>
            <footer style={styles.footer}>
                <p style={styles.footerText}>&copy; 2025 Your Interview App. All rights reserved.</p>
            </footer>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f9f9f9",
        color: "#333",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
    },
    header: {
        backgroundColor: "#007BFF",
        color: "white",
        padding: "20px 0",
        textAlign: "center",
    },
    title: {
        fontSize: "28px",
        fontWeight: "bold",
    },
    subtitle: {
        fontSize: "18px",
    },
    main: {
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    section: {
        marginBottom: "20px",
    },
    sectionTitle: {
        fontSize: "20px",
        marginBottom: "10px",
        borderBottom: "2px solid #007BFF",
        paddingBottom: "5px",
        color: "#007BFF",
    },
    textarea: {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        boxSizing: "border-box",
        marginBottom: "10px",
    },
    button: {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        color: "white",
        backgroundColor: "#007BFF",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        marginBottom: "20px",
    },
    text: {
        fontSize: "16px",
        lineHeight: "1.6",
        marginBottom: "10px",
    },
    footer: {
        backgroundColor: "#282c34",
        color: "white",
        textAlign: "center",
        padding: "10px 0",
        marginTop: "20px",
    },
    footerText: {
        fontSize: "14px",
    },
};

export default MainPage;